import { render } from "./PaymentReceiptCreateDocumentCustomerCard.vue?vue&type=template&id=d5270f62&scoped=true"
import script from "./PaymentReceiptCreateDocumentCustomerCard.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreateDocumentCustomerCard.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreateDocumentCustomerCard.vue?vue&type=style&index=0&id=d5270f62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5270f62"]])

export default __exports__